import { Component, DestroyRef, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CmsItem } from '@coin/shared/cms/util';
import { LegacyComponentsModule } from '@coin/shared/core/feature-legacy-components';
import { V2ButtonComponent, V2CheckboxComponent, V2TextInputComponent } from '@coin/shared/core/ui-storybook';
import { TranslateModule } from '@ngx-translate/core';
import { SelectMediaComponent } from '../../../dialogs/shared/select-media/select-media.component';
import { HtmlEditorComponent } from '../../shared/html-editor/html-editor.component';

@Component({
  selector: 'coin-email-main-body-image-text',
  templateUrl: './email-main-body-image-text.component.html',
  styleUrls: ['./email-main-body-image-text.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    V2CheckboxComponent,
    LegacyComponentsModule,
    HtmlEditorComponent,
    V2ButtonComponent,
    TranslateModule,
    FormsModule,
    V2TextInputComponent
  ]
})
export class EmailMainBodyImageTextComponent {
  private readonly dialog = inject(MatDialog);
  private readonly destroyRef = inject(DestroyRef);

  @Input() item: CmsItem<'main-body-image-text'>;
  @Input() showAdditionalEditOptions = false;
  @Input() contentEdit: boolean;

  public editPicture(): void {
    SelectMediaComponent.openDialog(this.dialog, { mediaType: 'image' })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(newImage => {
        if (newImage) {
          this.item.content.img = newImage.mediaUrl;
        }
      });
  }
}
